<template>
  <div id="bucket">
    <div class="button-group">
      <div class="name">{{ bucket.name }}</div>
      <div class="info">
        权限
        <span>{{ bucket.protectType }}</span>
      </div>
      <div class="info">
        创建时间
        <span>{{ bucket.createTime }}</span>
      </div>
      <el-button size="small" @click="deleteBu">删 除</el-button>
    </div>
    <el-tabs type="card" class="content" v-model="activeTab" tab-position="top">
      <el-tab-pane class="gailan" label="概览" name="0">
        <bucket-view :bucket="bucket" />
      </el-tab-pane>
      <el-tab-pane class="file" label="文件管理" name="1">
        <bucket-file :bucket="bucket" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import bucketView from "./bucketview.vue";
import bucketFile from "./bucketfile.vue";
export default {
  name: "bucket",
  props: {
    bucket: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      activeTab: "0"
    };
  },
  methods: {
    deleteBu() {
      this.$emit("deleteBu");
    }
  },
  components: {
    bucketView,
    bucketFile
  }
};
</script>

<style lang="scss">
#bucket {
  flex: 1 1 auto;
  overflow: hidden;
  background: #fff;
  padding: var(--padding);
  height: calc(100% - var(--padding) * 2);
  .content {
    height: calc(100% - 32px - var(--padding));
    .el-tab-pane {
      padding: 0 !important;
      height: 100% !important;
    }
  }
  & > .button-group {
    .name {
      flex: 1 1 auto;
      line-height: 32px;
      font-size: 20px;
    }
    .info {
      line-height: 32px;
      font-size: 14px;
      color: #929292;
      span {
        color: #000;
        margin: 0 15px;
      }
    }
    & > .el-button {
      min-width: 70px;
    }
  }
}
</style>
